
import { IAuthService } from '@/services/auth/IAuthService'
import { IUserService } from '@/services/user/IUserService'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class SettingsDropdown extends Vue {
  onLogout(): void {
    this.$services.get<IAuthService>('auth').logout()
    this.$services.get<IUserService>('user').removeLicense()
    this.$router.push('/auth')
  }
}
